<template>
  <div ref="container"
    :style="{
      'background-image': imageToShow,
    }"
  ><slot></slot></div>
</template>

<script>
  export default {
    name: 'cx-lazy-img',
    props: {
      src: {
        type: String,
        default: '',
        required: true
      },
      margin: {
        type: Number,
        default: 100,
      },
      threshold: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        observer: null,
        imageToShow: undefined
      }
    },
    mounted() {
      if (this.$refs 
        && this.$refs.container 
        && "IntersectionObserver" in window
      ) {
        this.observer = new IntersectionObserver((entries, observer) => {
          let {isIntersecting, intersectionRatio} = entries[0];
          if (isIntersecting) {
            this.loadImage();
            this.observer.unobserve(this.$refs.container);
          }
        }, {
          root: null, //document.querySelector('#app'),
          rootMargin: `${this.margin}px`,
          threshold: this.threshold
        });
        this.observer.observe(this.$refs.container);
      } else {
        this.loadImage();
      }
    },
    beforeDestroy() {
      this.observer && this.observer.unobserve(this.$refs.container);
    },
    methods: {
      loadImage: function() {
        this.imageToShow = `url(${this.src})`;
        console.log('[cx-lazy-img] Loading image:', this.imageToShow);
      }
    }
  }
</script>